import _ from 'lodash';

const DEFAULT_REFETCH_DEBOUNCE_MS = 1000;

export const createCoalescingRefetcher = (run, wait = DEFAULT_REFETCH_DEBOUNCE_MS) => {
  const state = { isFetching: false, isPending: false };

  const execute = () => {
    if (state.isFetching || !state.isPending) {
      return;
    }

    state.isPending = false;
    state.isFetching = true;

    const settle = () => {
      state.isFetching = false;

      if (state.isPending) {
        execute();
      }
    };

    Promise.resolve(run()).then(settle, settle);
  };

  const debouncedExecute = _.debounce(execute, wait, { maxWait: wait });

  const request = () => {
    state.isPending = true;
    debouncedExecute();
  };

  const cancel = () => {
    debouncedExecute.cancel();
    state.isPending = false;
  };

  return { request, cancel };
};
